import React, { useEffect, useState } from "react";
import DateRangeFilter from "./DateRangeFilter";

const ReportFilterBar = ({
  filters,
  onChange,
  onReset,
  filterSlot = null,
  filterSlotInline = false,
  searchPlaceholder = "Search...",
  showSearch = true,
}) => {
  const [searchValue, setSearchValue] = useState(filters.q || "");

  useEffect(() => {
    setSearchValue(filters.q || "");
  }, [filters.q]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchValue !== (filters.q || "")) {
        onChange({
          ...filters,
          q: searchValue,
          page: 1,
        });
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [searchValue]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  return (
    <div className="report-filter-bar mb-3">
      {/* Top Row */}
      <div className="row g-2 align-items-end">
        {/* Date Range - Left */}
        <div className={`${filterSlotInline && filterSlot ? "col-lg-4" : "col-lg-6"}`}>
          <DateRangeFilter filters={filters} onChange={onChange} onReset={onReset} />
        </div>

        {filterSlotInline && filterSlot && filterSlot}

        {/* Search - Right */}
        {showSearch && (
          <div className="col-12 col-lg-4 ms-lg-auto">
            <div style={{ width: "100%" }}>
              <label htmlFor="report-search" className="form-label">
                Search
              </label>
              <input
                id="report-search"
                type="search"
                className="form-control"
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        )}
      </div>

      {/* Additional Filters */}
      {filterSlot && !filterSlotInline && (
        <div className="row g-2 mt-1 align-items-end">{filterSlot}</div>
      )}
    </div>
  );
};

export default ReportFilterBar;
